import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('cr_token');
    const savedUser = localStorage.getItem('cr_user');
    if (token && savedUser) {
      // A corrupted value here used to throw and blank the whole app.
      let parsed = null;
      try { parsed = JSON.parse(savedUser); } catch { parsed = null; }
      if (!parsed) {
        localStorage.removeItem('cr_token');
        localStorage.removeItem('cr_user');
        setUser(null);
        setLoading(false);
        return;
      }
      setUser(parsed);
      api.get('/auth/me').then(r => {
        setUser(r.data);
        localStorage.setItem('cr_user', JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem('cr_token');
        localStorage.removeItem('cr_user');
        setUser(null);
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('cr_token', data.token);
    localStorage.setItem('cr_user', JSON.stringify(data.user));
    setUser(data.user);
    return data;
  };

  const register = async (formData) => {
    // Registration no longer signs anyone in — the account is unusable until
    // the email is confirmed, so there is no session to store here.
    const { data } = await api.post('/auth/register', formData);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('cr_token');
    localStorage.removeItem('cr_user');
    setUser(null);
  };

  const updateUser = (updates) => {
    const updated = { ...user, ...updates };
    setUser(updated);
    localStorage.setItem('cr_user', JSON.stringify(updated));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
